import React, { useState } from "react";
import { useCookies } from "react-cookie";

export default function AdminLogin() {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [, setCookie] = useCookies(["uuid"]);

  const handleId = (e) => {
    setId(e.target.value);
  };

  const handlePw = (e) => {
    setPw(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const response = await fetch("admin/check", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, pw }),
      });

      if (!response.ok) {
        throw new Error("서버 응답 실패");
      }

      const data = JSON.parse(await response.text());

      if (data.message === undefined) {
        const uuidCandidate =
          data?.[0]?.uuid !== undefined ? data[0].uuid : data.uuid;
        alert("로그인에 성공했습니다.");
        setCookie("uuid", uuidCandidate, { path: "/" });
        window.location.href = "/Adminpage";
      } else {
        setErrorMessage(data.message);
      }
    } catch (error) {
      console.error("오류 발생:", error);
      setErrorMessage(error.message || "로그인에 실패했습니다.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="admin-login">
      <div className="admin-login__glow" aria-hidden="true" />
      <section className="admin-login__card">
        <header className="admin-login__header">
          {/* <p className="admin-login__eyebrow">Bitsoop system</p> */}
          <h1 className="admin-login__title">슈퍼 관리자 로그인</h1>
          <p className="admin-login__subtitle">
            내부 운영 팀만 접근할 수 있습니다. 계정과 비밀번호를 입력해 주십시오.
          </p>
        </header>

        <form className="admin-login__form" onSubmit={handleSubmit}>
          <label className="admin-login__label" htmlFor="admin-id">
            ADMIN ID
          </label>
          <input
            id="admin-id"
            className="admin-login__input"
            type="text"
            value={id}
            onChange={handleId}
            onKeyDown={handleKeyDown}
            autoComplete="username"
          />

          <label className="admin-login__label" htmlFor="admin-password">
            ADMIN PASSWORD
          </label>
          <input
            id="admin-password"
            className="admin-login__input"
            type="password"
            value={pw}
            onChange={handlePw}
            onKeyDown={handleKeyDown}
            autoComplete="current-password"
          />

          {errorMessage && (
            <div className="admin-login__error" role="alert">
              {errorMessage}
            </div>
          )}

          <button
            type="submit"
            className="admin-login__submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "확인 중..." : "로그인"}
          </button>
        </form>

        <div className="admin-login__links">
          <a href="/">메인 페이지</a>
        </div>
      </section>
    </main>
  );
}